// DropIndicatorCustom.tsx
import { DropIndicatorProps } from "@atlaskit/pragmatic-drag-and-drop-react-drop-indicator/dist/types/tree-item";
import { useTheme } from "@mui/material";
import React from "react";

// type DropIndicatorCustomProps = {
//   instruction: DropIndicatorProps; // Use o tipo correto se disponível
// };
// export interface DropIndicatorCustomProps {
//   instruction: DropIndicatorProps["instruction"];
//   position?: "above" | "below"; // Adicione outros tipos de posição se necessário
// }

export type DropIndicatorCustomProps = {
  instruction: DropIndicatorProps["instruction"];
  position?: "above" | "below"; // Adicione outros tipos de posição se necessário
};
const DropIndicatorCustom: React.FC<DropIndicatorCustomProps> = ({
  instruction,
  position,
}) => {
  const theme = useTheme();
  // console.log("instruction", instruction);

  // Você pode usar a instruction para customizar o visual conforme necessário
  return (
    (position === "below" && instruction.type === "reorder-below") ||
    (position === "above" && instruction.type === "reorder-above" && (
      <div
        style={{
          position: "relative",
        }}
      >
        <div
          style={{
            height: 2,
            background:
              "linear-gradient(90deg," +
              theme.palette.primary.main +
              "," +
              theme.palette.background.textField +
              ")",
            borderRadius: 4,
            // margin: "4px 0",
            marginLeft: "8px",
            boxShadow: "0 2px 8px rgba(25, 118, 210, 0.15)",
          }}
        ></div>
        <div
          style={{
            position: "absolute",
            width: "8px",
            height: "8px",
            top: "-3px",
            // left: "-8px",
            flexShrink: 0,
            borderRadius: "50%",
            backgroundColor: theme.palette.primary.main,
            // border: `2px solid ${theme.palette.primary.main}`,
          }}
        ></div>
      </div>
    ))
  );
};

export default DropIndicatorCustom;
